import axios from '@axios'

export const state = {
  brokers: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allBrokers: (state) => state.brokers,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_BROKERS: (state, resp) => {
    if (!resp) return null
    state.brokers = resp.brokers
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  DELETE_BROKER: (state, broker) => {
    state.brokers = state.brokers.filter((w) => w.id !== broker.id)
  },
}

export const actions = {
  async getBrokers({ commit }, params = {}) {
    await axios
      .get('/api/brokers', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_BROKERS', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_BROKERS',
          err.response.status === 404 ? { brokers: [] } : null
        )
      })
  },
  async createBroker({ commit }, broker) {
    return axios.post(`/api/brokers`, broker)
  },
  async editBroker({ commit }, broker) {
    return axios.put(`/api/brokers`, broker)
  },
  async deleteBroker({ commit }, broker) {
    await axios.delete(`/api/brokers/${broker.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_BROKER', broker)
      }
    })
  },
}
